import httpClient from '../../api/httpClient'
import _ from 'lodash'
import { fetchWrapper } from '../../utils/helper'

const makeClientUser = (data) => {
  const config = data.config
  const hide = config !== '[]' ? JSON.parse(config).hide : []
  return {
    ...data,
    hiddenFields: { agency_earnings: hide.indexOf('agency_earnings') !== -1 },
  }
}

const defaultPermissions = { agency_earnings: false }
export default {
  state: {
    clientUser: {},
    clientUsers: [],
    registerLinks: [],
    permissions: {
      edit: { ...defaultPermissions },
      new: { ...defaultPermissions },
    },
    permissionsList: [
      {
        name: 'agency_earnings',
        label: 'Agency Earnings',
      },
    ],
    loading: false,
    error: '',
    success: '',
  },

  getters: {
    clientUser: (state) => state.clientUser,
    clientUsers: (state) => state.clientUsers,
    permissions: (state) => state.permissions,
    permissionsList: (state) => state.permissionsList,
    registerLinks: (state) => state.registerLinks,
    loading: (state) => state.loading,
    error: (state) => state.error,
    success: (state) => state.success,
  },

  mutations: {
    update(state, { path, value }) {
      _.set(state, path, value)
    },
  },

  actions: {
    async fetchClientById({ commit }, id) {
      const { data } = await httpClient.get(`/clients/${id}`)
      commit('update', { path: 'clientUser', value: data })
    },
    async fetchClientUsers({ commit }, id) {
      let { data } = await httpClient.get(`/admin/client/${id}/users`)
      data = data.map((item) => makeClientUser(item))
      commit('update', { path: 'clientUsers', value: data })
    },
    async fetchRegisterLinks({ commit }, id) {
      const { data } = await httpClient.get(`/admin/client/${id}/users/register-links`)
      commit('update', { path: 'registerLinks', value: data })
    },
    async fetchData({ commit, dispatch }, id) {
      fetchWrapper(
        async (id) => {
          await dispatch('fetchClientById', id)
          await dispatch('fetchClientUsers', id)
          await dispatch('fetchRegisterLinks', id)
        },
        commit,
        [id],
      )
    },
    createPermission({ commit }, { id, userId, permissions, email }) {
      fetchWrapper(
        async (id, userId, permissions, email) => {
          await httpClient.post(`/admin/client/users`, {
            id,
            user_id: userId,
            hide: permissions,
            email,
          })
        },
        commit,
        [id, userId, permissions, email],
        { successMessage: 'Permissions were successfully created!' },
      )
    },
    updatePermission({ commit }, { id, userId, permissions }) {
      fetchWrapper(
        async (id, userId, permissions) => {
          await httpClient.put('/admin/client/users', {
            id,
            user_id: userId,
            hide: permissions,
          })
        },
        commit,
        [id, userId, permissions],
        { successMessage: 'Permissions were successfully updated!' },
      )
    },
    deletePermission({ commit }, { id, userId }) {
      fetchWrapper(
        async (id, userId) => {
          await httpClient.delete(`/admin/client/${id}/users/${userId}`)
        },
        commit,
        [id, userId],
        { successMessage: 'User has been successfully deleted!' },
      )
    },
    createRegisterLink({ commit }, { id, email, permissions }) {
      fetchWrapper(
        async (id, email, permissions) => {
          try {
            await httpClient.post(`/admin/client/${id}/users/create-register-link`, {
              email,
              hide: permissions,
            })
          } catch (error) {
            if (error.response && error.response.status === 409 && error.response.data?.code) {
              const responseCode = error.response.data.code

              switch (responseCode) {
                case 'LINK_ALREADY_EXISTS':
                  throw new Error('A register link for this email already exists.')
                case 'USER_EMAIL_ALREADY_EXISTS':
                  throw new Error('A user with this email already exists.')
                default:
                  throw error
              }
            }

            throw error
          }
        },
        commit,
        [id, email, permissions],
        { successMessage: 'Register link was successfully created!' },
      )
    },
  },
}
